/* eslint-disable */
(function(win, doc, script) {
    let elem = doc.getElementsByTagName(script)[0],
        scriptElem = doc.createElement(script)

    scriptElem.async = true;
    scriptElem.src = "https://www.googletagmanager.com/gtag/js?id=UA-99618214-3";
    elem.parentNode.insertBefore(scriptElem, elem);

    win.dataLayer = win.dataLayer || [];

    gtag('js', new Date());
    gtag('config', 'UA-99618214-3');
  })(window, document, "script");

  function gtag(){ window.dataLayer.push(arguments); }
